import React, { useState } from 'react';
import './Footer.css';
import { FaFacebookF, FaInstagram, FaTwitter, FaYoutube } from 'react-icons/fa';

const Footer = () => {
  const [openSection, setOpenSection] = useState(null);

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  const footerSections = [
    {
      title: 'ABOUT US',
      content: 'At Spinelle Diamond Jewellery, we believe that every diamond tells a story – a story of beauty, elegance, and timelessness. Based in the vibrant city of Hyderabad.'
    },
    {
      title: 'EXPLORE',
      links: ['Sizing Guide', 'Resizing & Repairs', 'Certifications', 'Design With Us', 'Blogs']
    },
    {
      title: 'SHOP',
      links: ['Rings', 'Earrings', 'Pendant Sets', 'Bracelets', 'Kids Jewellery']
    },
    {
      title: 'INFORMATION',
      links: ['Terms of Service', 'Privacy Policy', 'Return Policy', 'Shipping Policy', 'Cancellations & Refunds']
    },
    {
      title: 'LET’S CONNECT',
      socials: true
    }
  ];

  return (
<footer className="footer">
  <div className="footer-container">
    {footerSections.map((section, index) => (
      <div className="footer-section" key={index}>
        <div className="footer-header" onClick={() => toggleSection(index)}>
            <div className="footer-header1">
      {section.title === "ABOUT US" && (
        <div className="footer-logo-text">SPINELLE ✦</div>
      )}
   
          {section.title}   </div>
          <span className="toggle-icon">{openSection === index ? '-' : '+'}</span>
        </div>
        <div className={`footer-content ${openSection === index ? 'open' : ''}`}>
          {section.content && <p>{section.content}</p>}
          {section.links && (
            <ul>
              {section.links.map((link, idx) => (
                <li key={idx}>{link}</li>
              ))}
            </ul>
          )}
          {section.socials && (
            <div className="social-icons">
              <a href="#"><FaFacebookF /></a>
              <a href="#"><FaInstagram /></a>
              <a href="#"><FaTwitter /></a>
              <a href="#"><FaYoutube /></a>
            </div>
          )}
        </div>
      </div>
    ))}
  </div>
    <div className="footer-bottom">
    © 2025, Spinelle Jewelry. All Rights Reserved.
  </div>
</footer>

  );
};

export default Footer;
